import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let states = {};
const modulesFiles = require.context("./modules", true, /\.js$/);
//遍历modules文件夹内文件 导出的json数组
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  for (const m in value.default) {
    //state为 modules文件夹内文件 导出名称，如有多个导出部分，可在这里判断存入不同json数组
    if (m == "state") states = Object.assign(states, value.default[m]);
  }
  return modules;
}, {});

const store = new Vuex.Store({
  state: states
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js